module.exports = __webpack_public_path__ + "static/img/5-2.8105979.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/6/5-2.png
// module id = 273
// module chunks = 0